import { render, staticRenderFns } from "./ProgramRadioCard.vue?vue&type=template&id=174eb055&scoped=true"
import script from "./ProgramRadioCard.vue?vue&type=script&lang=js"
export * from "./ProgramRadioCard.vue?vue&type=script&lang=js"
import style0 from "./ProgramRadioCard.vue?vue&type=style&index=0&id=174eb055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174eb055",
  null
  
)

export default component.exports